import request from '@/utils/request'

/**
 * 管理端通用图片上传
 * ---------------------------------------------------------------------------
 * 后端走 FileStorageService（本地磁盘 / 七牛云按 file.storage.type 路由），
 * 并登记 file_records —— 传上来的图不会变成「文件管理」里的孤儿。
 *
 * @param {File} file 浏览器 File 对象
 * @param {string} [bizType] 业务类型（OTHER / SYSTEM_LOGO / FRIEND_LINK_LOGO ...）
 * @returns {Promise} 成功时 data.url 为相对路径（/uploads/xxx）或七牛完整地址，
 *                    可直接存库
 */
export function uploadImage(file, bizType) {
  const form = new FormData()
  form.append('file', file)
  if (bizType) {
    form.append('bizType', bizType)
  }
  return request({
    url: '/admin/upload',
    method: 'post',
    data: form,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
